import { render, staticRenderFns } from "./ImagesSelection.vue?vue&type=template&id=424bdbe0&"
import script from "./ImagesSelection.vue?vue&type=script&lang=js&"
export * from "./ImagesSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424bdbe0')) {
      api.createRecord('424bdbe0', component.options)
    } else {
      api.reload('424bdbe0', component.options)
    }
    module.hot.accept("./ImagesSelection.vue?vue&type=template&id=424bdbe0&", function () {
      api.rerender('424bdbe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/ImagesSelection.vue"
export default component.exports